import React, { useCallback } from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import styled from 'styled-components';
import ListCell from './ListCell';
const DroppableContent = styled.div `
  width: ${({ width }) => width || '13.25rem'};
`;
const SortingList = ({ idListKey = 'id', displayKey = 'name', listData, width, lang, onMove, onDelete, showIndex = false, }) => {
    const renderCell = useCallback(({ data, index }) => {
        return (React.createElement(ListCell, { id: data[idListKey], index: index, label: data[displayKey], lang: lang, onDelete: onDelete, fixed: data.fixed, showIndex: showIndex }));
    }, [displayKey, idListKey, lang, onDelete, showIndex]);
    return (React.createElement("div", null,
        React.createElement(DragDropContext, { onDragEnd: result => result.destination &&
                onMove &&
                onMove({
                    dragIndex: result.source.index,
                    hoverIndex: result.destination.index,
                    list: listData,
                }) },
            React.createElement(Droppable, { droppableId: "droppable" }, provided => (React.createElement(DroppableContent, Object.assign({ ref: provided.innerRef, width: width }, provided.droppableProps),
                listData.map((data, index) => renderCell({ data, index })),
                provided.placeholder))))));
};
export default SortingList;
//# sourceMappingURL=index.js.map